import React from "react";
import Navigation from "./navigation";
import Layout from "./layout";
import Sidebar from "./Components/Sidebar/Sidebar";

function App() {
  return (
    <>
      <Navigation />
    </>
  );
}

export default App;
